import { MmdWasmPhysicsMetadataEncoder } from "./mmdWasmPhysicsMetadataEncoder";
import { MmdWasmPhysicsRuntime } from "./mmdWasmPhysicsRuntime";
import { PhysicsClock } from "./physicsClock";
/**
 * Mmd wasm integrated physics runtime helper object
 *
 * For use physics integrated mmd wasm runtime you need to pass this object to the mmd runtime constructor
 */
export class MmdWasmPhysics {
    _scene;
    /**
     * Create mmd wasm integrated physics runtime helper object
     * @param scene scene
     */
    constructor(scene) {
        this._scene = scene;
    }
    /**
     * create mmd wasm physics runtime
     *
     * MmdWasmPhysicsRuntime must be disposed when it is no longer needed
     * @param mmdRuntime mmd wasm runtime
     * @returns mmd wasm physics runtime
     */
    createRuntime(mmdRuntime) {
        return new MmdWasmPhysicsRuntime(mmdRuntime);
    }
    /**
     * create physics clock
     * @returns physics clock
     */
    createPhysicsClock() {
        return new PhysicsClock(this._scene.getEngine());
    }
    /**
     * create physics metadata encoder
     * @param physicsRuntime physics runtime
     * @param logger logger
     * @returns physics metadata encoder
     */
    createMetadataEncoder(physicsRuntime, logger) {
        return new MmdWasmPhysicsMetadataEncoder(physicsRuntime, logger);
    }
}
